import { Button, Drawer, SmartContentDisplay } from '@act/storybook';
import { Box, Divider, Typography } from '@mui/material';
import HtmlDisplayer from 'react-components/components/html-displayer';
import { membersAppSelectors } from 'redux/slices/memberSlice';
import { metaSliceSelectors } from 'redux/slices/metaSlice.hooks';
import { needsSelectors } from 'redux/slices/needs.slice';
import { InfoContainer, LabeledDatum } from 'toolkit/styles/dataDisplay';
import NeedHistory from '../components/history/need-history';
import NeedTimeAlert from './components/need-time-alert';

export interface NeedDetailSideDrawerProps {
  open: boolean;
  onClose: () => void;
  needId: number;
}

export default function NeedDetailSideDrawer({
  open,
  onClose,
  needId,
}: NeedDetailSideDrawerProps) {
  const needMetadata = metaSliceSelectors.useSelectNeedsMetadata();
  const need = needsSelectors.useSelectNeedById(needId);
  const member = membersAppSelectors.useSelectMemberById(need?.memberId);
  const issue = needMetadata.data.issues.find(i => i.id === need.issueId);
  const category = needMetadata.data.categories.find(
    c => c.id === issue?.categoryId
  );
  const domain = needMetadata.data.domains.find(
    d => d.id === category?.domainId
  );

  return (
    <Drawer open={open} onClose={onClose} title={`Need for ${member?.name}`}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          height: '100%',
          minHeight: 0,
        }}
      >
        <Box sx={{ flex: 1, overflow: 'auto', padding: '0 12px' }}>
          <div className="info">
            <InfoContainer>
              <LabeledDatum label={'Domain'} datum={domain?.label} />
              <LabeledDatum label={'Category'} datum={category?.label} />
              <LabeledDatum label={'Issue'} datum={issue?.label} />
              <LabeledDatum
                label={'Reason'}
                datum={
                  <SmartContentDisplay maxHeight={150}>
                    <HtmlDisplayer innerHtml={need?.reason} />
                  </SmartContentDisplay>
                }
              />
            </InfoContainer>
          </div>
          <div className="alert">
            <NeedTimeAlert need={need} />
          </div>
          <Divider sx={{ margin: '24px -12px 8px' }} />
          <div className="history-header">
            <Typography variant="titleMedium">History</Typography>
            <Box sx={{ justifySelf: 'flex-end' }}></Box>
          </div>
          <NeedHistory need={need} editMode={false} detailMode={true} />
        </Box>
        <Box
          sx={{
            padding: '16px 24px',
            marginTop: 'auto',
            display: 'flex',
            justifyContent: 'flex-end',
          }}
        >
          <Button onClick={onClose} sx={{ padding: '8px 24px' }}>
            Close
          </Button>
        </Box>
      </Box>
    </Drawer>
  );
}
